import React from 'react'

import MicrosoftSocialButton from '../shared/MicrosoftSocialButton'
import {Auth0Connection} from 'js/types'
import {ComponentSize, FlexBox, FlexDirection} from '@influxdata/clockface'
import GoogleSocialButton from '../shared/GoogleSocialButton'

export type SocialFocus = 'microsoft' | 'google'

interface Props {
  handleSocialClick: (connection: Auth0Connection) => void
  handleChooseEmail: () => void
  focus: SocialFocus
}

const SocialFocusedSignup = ({
  handleSocialClick,
  handleChooseEmail,
  focus,
}: Props): JSX.Element => {
  const socialButton = () => {
    switch (focus) {
      case 'microsoft':
        return <MicrosoftSocialButton handleSocialClick={handleSocialClick} />
      case 'google':
        return <GoogleSocialButton handleSocialClick={handleSocialClick} />
    }
  }

  return (
    <FlexBox
      direction={FlexDirection.Column}
      margin={ComponentSize.Large}
      className="focused-container"
    >
      {socialButton()}
      <a onClick={handleChooseEmail} className="focused-link">
        or continue with email
      </a>
    </FlexBox>
  )
}

export default SocialFocusedSignup
